import React from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import {ModalActions} from "../../../Store/Modal/Slice";
import {
  CANCEL_SHIPMENT_MODAL,
  EDIT_PICKUP_MODAL,
  SHIPPING_DETAIL_MODAL
} from "../../../Store/Modal/Types";
import DetailShipmentComponent from "../DetailShipmentComponent/DetailShipmentComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencilAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
import {isDeleteVisible, isEditVisible} from "../../../Utils/Utils";
import {ContactsActions} from "../../../Store/Contact/Slice";
import {Customer} from "../../../Models/Customer";
import {PaymentTypeActions} from "../../../Store/PaymentType/Slice";
import {PackingTypesActions} from "../../../Store/PackingType/Slice";

const ShippingDetailModal = () => {

  const {
    ModalReducer : {shippingDetailModal: {data, open}},
    CompanyReducer: {branch_selected, company_selected},
    PaymentReducer: {paymentTypes},
    PackingReducer: {packingTypes}
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const closeShippingModal = () => {
    dispatch(ModalActions.closeModal({modal: SHIPPING_DETAIL_MODAL}));
  };

  const cancelShipment = () => {
    dispatch(ModalActions.openModal({
      modal: CANCEL_SHIPMENT_MODAL,
      data: data?.shippingInfo
    }));
  };

  const editShipment = () => {
    dispatch(ModalActions.openModal({modal:EDIT_PICKUP_MODAL, data: data?.shippingInfo}));
    dispatch(ContactsActions.getContacts({customer:(branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY}));
    !paymentTypes.length && dispatch(PaymentTypeActions.getPaymentTypes());
    !packingTypes.length && dispatch(PackingTypesActions.getPackingTypes());
  };

  return (
    <Modal size="lg" toggle={closeShippingModal} isOpen={open}>
      <ModalHeader className="border-0 text-uppercase mx-2" toggle={closeShippingModal}>
        Guía # <b className="text-danger">{data?.shippingInfo?.consecutive}</b>

        {isDeleteVisible(data?.shippingInfo?.status) &&
        <FontAwesomeIcon onClick={cancelShipment} className="s-detail-icon" icon={faTrash}/>}

        {isEditVisible(data?.shippingInfo?.status) &&
        <FontAwesomeIcon onClick={editShipment} className="s-detail-icon" icon={faPencilAlt}/>}

      </ModalHeader>

      <ModalBody>

        <DetailShipmentComponent isShipment={data?.isShipment} data={data?.shippingInfo} />

        <div className="py-3"/>
      </ModalBody>
    </Modal>
  );
};

export default ShippingDetailModal;
